const colors = {
  IFX_BRAND_BLUE: "#055BD6",  // Primary Brand Color 
  IFX_BRAND_GREEN: "#31D37A",
  IFX_BRAND_PURPLE: "#6D12FC",
  IFX_BRAND_FUSCIA: "#AF16FC",
  IFX_BRAND_TYPE_GRAY: "#58626D",  // for use in text and icons
  IFX_BRAND_LIME: "#ABDB4F",
  IFX_BRAND_CYAN: "#05BFC4",
  IFX_STOPLIGHT_GREEN: "#31D37A",  // same as IFX_BRAND_GREEN
  IFX_STOPLIGHT_YELLOW:  "#F6D949",
  IFX_STOPLIGHT_RED: "#EA2D52",

  // Standard non IFX colors
  GREY_DARK: "#595959",
  GREY_LIGHT: "#C0C0C0",
  GREY_LIGHTER: "#e0e0e0",
  GREY_EXTRALIGHT: "#f8f9fa",

  TEXT_GREY_LIGHT: "#ccc",
  TEXT_GREY: "#666",
  TEXT_GREY_DARK: "#333",

  // Rogue colors chosen by developers
  OFF_BRAND_LIGHT_BLUE: "#abc3dc",
  OFF_BRAND_INTERACT_BLUE: "#32AFD9",

// these are old brand colors
/*
  IFX_BRAND_BLUE_DARK: "#003366",
  IFX_BRAND_RED: "#cc3f54",
  IFX_NAVY_LIGHT: "#356EA9",
  IFX_BLUE: "#3AD7FF",
  IFX_BLUE_BRIGHT: "#00FFCC",
  IFX_TEAL: "#027E9C",
  IFX_GOLD: "#FFCC00",
  IFX_GOLD_LIGHT: "#FBE691",
  IFX_GOLD_EXTRALIGHT: "#fff3c2",
  IFX_ORANGE: "#fd8e2e",
  IFX_ORANGE_MUTED: "#c67b46",
  IFX_GREEN: "rgba(8, 100, 17, 1.0)",
  IFX_GREEN_LIGHT: "#1c9b99",
  IFX_GREEN: '#37873f',
  */
};

export default colors;
